/* eslint-disable */

const defaultColors = {
  htmlBody: '#4a4a4a',
  headerBackground: '#FFFFFF',
  botBackground: '#FFE24B',
  botColor: '#000000',
  chatBubbleBackground: '#E4E4E4',
  chatBubbleColor: '#212121',
  widgetHeaderDividerLine: '#C4C4C4',
  headerBtnColor: '#757575',
};

const images = {
  icimsLogo: 'https://www.icims.com/img/global/icims-logo-main.png',
  acmeLogo: 'https://s3-us-west-2.amazonaws.com/textrecruit-public/assets/chat/org_logo.png',
  hero: 'https://s3-us-west-2.amazonaws.com/textrecruit-public/assets/chat/hero_image.png',
};

/**
 * Returns CSS string with values provided from styleObj.
 * @param {Object} styleObj
 */
export const cssString = (styleObj) => {
  // Main
  const {
    headerFontColor,
    headerBackgroundColor = defaultColors.headerBackground,
    widgetHeaderDividerLine = defaultColors.widgetHeaderDividerLine, // TODO: should default to border: 1px solid #C4C4C4 (see Figma).
    organizationLogo = images.icimsLogo || images.acmeLogo,
    fullScreenLogoUrl = images.hero,
    brandedChatBubbleColor = defaultColors.chatBubbleBackground,
    brandedChatBubbleFontColor = defaultColors.chatBubbleColor,
  } = styleObj;

  // Ari/Sender bubble background color for inbound messages
  const {
    brandedChatSenderBackgroundColor = defaultColors.botBackground,
    brandedChatSenderFontColor = defaultColors.botColor,
  } = styleObj;

  // Buttons
  const { primaryButtonBackgroundColor, primaryButtonFontColor, primaryButtonBorderColor } =
    styleObj;

  let r = `
  body { color: ${defaultColors.htmlBody};}
  .main-container { background-color: ${headerBackgroundColor}; }
  .ui { color: #4a4a4a; }
	.widget-header { background-color: ${headerBackgroundColor}; color: ${headerFontColor}; }
	.minimize-button { color: ${headerFontColor || defaultColors.headerBtnColor}; }
	.close-button { color: ${headerFontColor || defaultColors.headerBtnColor}; }
  .banner { background-color: ${headerBackgroundColor}; background-image: url(${fullScreenLogoUrl});}
  .msg-title-icon.inbound { background-color: ${brandedChatSenderBackgroundColor}; color: ${brandedChatSenderFontColor}; }
  .msg-title-icon.inbound.ari { background-color: ${brandedChatSenderBackgroundColor}; color: ${brandedChatSenderFontColor}; }
  .msg__box { border-radius: 4px; }
  .modal__header { background-color: ${primaryButtonBackgroundColor}; color: ${primaryButtonFontColor}; }
  .header-controls-area > button > svg { color: ${headerFontColor}; }
  .app-btn.primary { background-color: ${primaryButtonBackgroundColor}; color: ${primaryButtonFontColor}; border: 1px solid ${primaryButtonBorderColor}; }
  .app-btn.primary.mobile { background-color: inherit; color: ${primaryButtonBackgroundColor}; }
  .MuiButton-containedPrimary { background-color: ${primaryButtonBackgroundColor}; color: ${primaryButtonFontColor};
   transition-property: background-color, border, box-shadow, filter; }
  .MuiButton-containedPrimary:hover { background-color: ${primaryButtonBackgroundColor}; color: ${primaryButtonFontColor}; filter: brightness(90%); }
  .btn-send { background-color: ${primaryButtonBackgroundColor}; color: ${primaryButtonFontColor}; }
  .btn-send:hover { background-color: ${primaryButtonBackgroundColor}; filter: brightness(90%); }
	.btn-send.MuiButtonBase-root.Mui-disabled { background-color: ${primaryButtonBackgroundColor}; color: ${primaryButtonFontColor}; opacity: 0.4; }
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline { border-color: ${primaryButtonBackgroundColor} !important; }
  .MuiFormLabel-root.Mui-focused { color: ${primaryButtonBackgroundColor} !important; }
  .MuiButtonBase-root.MuiButton-root.MuiButton-text:first-of-type { color: ${primaryButtonBackgroundColor}; }               /* secondary modal button (no) */
  .MuiButtonBase-root.MuiButton-root.MuiButton-contained:last-of-type { background-color: ${primaryButtonBackgroundColor};
   color: ${primaryButtonFontColor}; }            /* primary modal button (yes) */
  .MuiButtonBase-root.MuiButton-root.MuiButton-text:hover { filter: brightness(90%); } /* primary modal hover */
  .header-logo-area { background: url("${organizationLogo}") no-repeat; background-size: contain; }
	.header-divider-line { background-color:${widgetHeaderDividerLine}; height: 2px; border: 1px solid;}
	.MuiButton-containedPrimary.Mui-disabled { background-color: ${primaryButtonBackgroundColor}; color: ${primaryButtonFontColor}; opacity: 0.4; }
	.icims-mui-acs-icon-ari { background-color: ${brandedChatSenderBackgroundColor}; color: ${brandedChatSenderFontColor}; }
	.icims-mui-acs-msg { background-color: ${brandedChatBubbleColor}; color: ${brandedChatBubbleFontColor}; }
  `;

  const { customCss } = styleObj;
  if (customCss && customCss.trim()) {
    r += customCss;
  }
  return r;
};
